/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  VerifyIdentityProviderConnectionRequestBody,
  VerifyIdentityProviderConnectionRequestBody$Outbound,
  VerifyIdentityProviderConnectionRequestBody$outboundSchema,
} from "../components/verifyidentityproviderconnectionrequestbody.js";

export type VerifyIdentityProviderConnectionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type VerifyIdentityProviderConnectionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  verifyIdentityProviderConnectionRequestBody:
    VerifyIdentityProviderConnectionRequestBody;
};

/** @internal */
export type VerifyIdentityProviderConnectionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const VerifyIdentityProviderConnectionSecurity$outboundSchema:
  z.ZodMiniType<
    VerifyIdentityProviderConnectionSecurity$Outbound,
    VerifyIdentityProviderConnectionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function verifyIdentityProviderConnectionSecurityToJSON(
  verifyIdentityProviderConnectionSecurity:
    VerifyIdentityProviderConnectionSecurity,
): string {
  return JSON.stringify(
    VerifyIdentityProviderConnectionSecurity$outboundSchema.parse(
      verifyIdentityProviderConnectionSecurity,
    ),
  );
}

/** @internal */
export type VerifyIdentityProviderConnectionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  VerifyIdentityProviderConnectionRequestBody:
    VerifyIdentityProviderConnectionRequestBody$Outbound;
};

/** @internal */
export const VerifyIdentityProviderConnectionRequest$outboundSchema:
  z.ZodMiniType<
    VerifyIdentityProviderConnectionRequest$Outbound,
    VerifyIdentityProviderConnectionRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      verifyIdentityProviderConnectionRequestBody:
        VerifyIdentityProviderConnectionRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        verifyIdentityProviderConnectionRequestBody:
          "VerifyIdentityProviderConnectionRequestBody",
      });
    }),
  );

export function verifyIdentityProviderConnectionRequestToJSON(
  verifyIdentityProviderConnectionRequest:
    VerifyIdentityProviderConnectionRequest,
): string {
  return JSON.stringify(
    VerifyIdentityProviderConnectionRequest$outboundSchema.parse(
      verifyIdentityProviderConnectionRequest,
    ),
  );
}
